import type { PopupButtonConfig } from '@onetext/api';
import { TEXT_TRANSFORM } from '@onetext/api';

export const buttonConfig : PopupButtonConfig = {
    level: {
        primary: {
            style: {
                text: {
                    base:  '#ffffff',
                    hover: '#ffffff'
                },
                background: {
                    base:  '#83bfb5',
                    hover: '#a5d0c9'
                }
            }
        },
        secondary: {
            style: {
                text: {
                    base:  'rgb(80,109,111)',
                    hover: 'rgb(80,109,111)'
                },
                background: {
                    base:  'rgba(165,208,201,0.25)',
                    hover: 'rgba(165,208,201,0.4)'
                }
            }
        }
    },
    size: {
        default: {
            style: {
                textTransform: TEXT_TRANSFORM.UPPERCASE,
                borderRadius:  '0.25rem',
                letterSpacing: '4px',
                height:        '46px'
            }
        }
    }
};
